<template>
  <quote-list-block
    :empty-result-label="''"
    :title="i18n.t(`/financialservices/lease/modal/privatelease/tires/label/a`)"
  >
    <template v-if="selectedProducts.length" #header>
      <div class="vat">{{ i18n.t('/Common/Btw') }}</div>
      <template v-if="showPurchasePrice">
        <div class="price price-incl" :data-qa="`${blockType}-price-incl-header`">
          {{ i18n.t('/Common/Verkoopprijs') }}
        </div>
        <div class="price price-excl" :data-qa="`${blockType}-price-excl-header`">
          {{ i18n.t('/Common/Inkoopprijs') }}
        </div>
      </template>
      <template v-else>
        <div class="price price-incl" :data-qa="`${blockType}-price-incl-header`">
          {{ i18n.t('/Common/InclBtw') }}
        </div>
        <div class="price price-excl" :data-qa="`${blockType}-price-excl-header`">
          {{ i18n.t('/Common/ExclBtw') }}
        </div>
      </template>
    </template>

    <template v-if="selectedProducts.length" #body>
      <li
        v-for="(selectedProduct, index) in selectedProducts"
        :key="index"
        class="row"
        :class="{ 'is-active': isTyres(selectedProduct) }"
        :data-qa="getDataQaTag(selectedProduct)"
      >
        <button
          v-if="isEditable"
          class="add"
          data-qa="selected-tyres-toggle-button"
          @click="toggleItem(selectedProduct)"
        >
          <span class="sr-only">
            {{ selectedProduct.name }}
            <span>{{ i18n.t('/ProductBlocks/AddToSelection') }}</span>
          </span>
          <icon v-if="isTyres(selectedProduct)" class="icon-add" icon="check-bold" />
        </button>
        <div class="title">{{ selectedProduct.Name }}</div>
        <div class="vat">{{ formatNumber(selectedProduct.Price.BtwRate) }}%</div>

        <template v-if="showPurchasePrice">
          <div class="price price-excl" data-qa="purchaseprice-excl">
            {{ i18n.n(selectedProduct.Price.PurchaseExcl, 'currency') }}
          </div>
          <div class="price price-incl" data-qa="price-excl">
            {{ i18n.n(selectedProduct.Price.Excl, 'currency') }}
          </div>
        </template>
        <template v-else>
          <div class="price price-excl" data-qa="price-excl">
            {{ i18n.n(selectedProduct.Price.Excl, 'currency') }}
          </div>
          <div class="price price-incl" data-qa="price-incl">
            {{ i18n.n(selectedProduct.Price.Incl, 'currency') }}
          </div>
        </template>
      </li>
    </template>
  </quote-list-block>
</template>

<script>
import QuoteListBlock from '@/components/generic/presentational/molecules/quoteListBlock/QuoteListBlock.vue'
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'

export default {
  components: {
    QuoteListBlock,
    Icon,
  },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    selectedProducts: {
      type: Array,
      default: () => [],
    },
    showPurchasePrice: {
      type: Boolean,
      default: false,
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
    blockType: {
      type: String,
      required: true,
    },
  },
  emits: ['mark-product-as-tyres'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  methods: {
    getDataQaTag(selectedProduct) {
      if (selectedProduct.IsPCQMGeneratedId) return 'is-custom-product'
      if (selectedProduct.selectedProduct == 'SHOPPING_CART') return 'is-shopping-cart-product'
      return ''
    },
    formatNumber(value) {
      return Number(value)
    },
    isTyres(selectedProduct) {
      return selectedProduct?.AllWeatherTyresPL
    },
    toggleItem(selectedProduct) {
      this.$emit('mark-product-as-tyres', selectedProduct)
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.row) {
  grid-template-columns: 3em auto 3em 6em 6em;
  grid-template-areas: 'add title vat price-excl price-incl';
}

button {
  margin-top: 0.1em;
}

button + button {
  margin-left: 0.5em;
  text-align: right;
}

.loader {
  font-size: 0.5em;
  transform: translateY(0.5em);
  margin-bottom: 0;
}

.add {
  border-radius: 50%;
  width: 1.5em;
  height: 1.5em;
  border: 1px solid $color-primary;
  color: $white;
  background-color: $white;

  .is-active & {
    background-color: $color-primary;
  }

  [disabled] & {
    background-color: #a3b8c0;
    border-color: #dae2e5;
  }
}

.icon-add {
  @include icon(0.75em);
}
</style>
